import { getEntry, getNotSetValue } from 'conversations-async-data/indexed-async-data/operators/getters';
import { createSelector } from 'reselect';
import { getIndexedAsyncMoveStatuses } from './getIndexedAsyncMoveStatuses';
const getThreadIdFromProps = (__state, {
  threadId
}) => threadId;
export const getAsyncMoveStatus = createSelector([getThreadIdFromProps, getIndexedAsyncMoveStatuses], (threadId, indexedAsyncMoveStatuses) => threadId ? getEntry(threadId, indexedAsyncMoveStatuses) : getNotSetValue(indexedAsyncMoveStatuses));